module.exports = __webpack_public_path__ + "static/media/16.60fb225b.png";